import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trophy, Crown, Trash } from "@phosphor-icons/react";

export function ContestTab() {
  const [data, setData] = useState(null);

  const load = () => api.get("/admin/contest").then(r => setData(r.data)).catch(() => toast.error("Error cargando concurso"));
  useEffect(() => { load(); }, []);

  const setWinner = async (e) => {
    if (!window.confirm(`¿Marcar "${e.title}" como GANADORA del mes? Esto le dará la insignia de Creador Destacado.`)) return;
    try {
      await api.post(`/admin/contest/${e.id}/winner`);
      toast.success("¡Ganadora marcada! 👑");
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Error"); }
  };

  const removeEntry = async (e) => {
    if (!window.confirm(`¿Eliminar la participación de "${e.title}"?`)) return;
    try {
      await api.delete(`/admin/contest/${e.id}`);
      toast.success("Participación eliminada");
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Error"); }
  };

  if (!data) return <p className="text-white/40 text-center py-12">Cargando concurso…</p>;

  return (
    <div className="space-y-4" data-testid="contest-tab">
      <div className="rounded-2xl border border-[#FFB800]/30 bg-[#FFB800]/5 p-5">
        <h3 className="font-display text-lg font-bold flex items-center gap-2">
          <Trophy size={18} weight="fill" className="text-[#FFB800]" /> Concurso · {data.label}
        </h3>
        <p className="text-sm text-white/60 mt-1">
          {data.entries.length} participantes. La comunidad vota; tú eliges al ganador definitivo
          entre el Top 5 (regla anti-bots). El ganador recibe la insignia "Creador Destacado".
        </p>
      </div>

      {data.entries.length === 0 && (
        <p className="text-white/40 text-center py-8">Aún no hay participaciones este mes.</p>
      )}

      <div className="space-y-2" data-testid="admin-contest-list">
        {data.entries.map((e, i) => (
          <div key={e.id} className={`rounded-xl border p-3 flex flex-wrap items-center gap-3 ${e.winner ? "border-[#FFB800]/60 bg-[#FFB800]/5" : "bg-[#121212] border-white/5"}`}>
            <span className="font-display font-black text-xl w-7 text-center" style={{ color: i < 5 ? "#FFB800" : "rgba(255,255,255,0.25)" }}>{i + 1}</span>
            <div className="flex-1 min-w-[160px]">
              <p className="font-display font-bold flex items-center gap-1.5">
                {e.winner && <Crown size={14} weight="fill" className="text-[#FFB800]" />}
                {e.title}
              </p>
              <p className="text-xs text-white/50">
                {e.artist_name} · {e.phone}
                {e.tiktok_url && <> · <a href={e.tiktok_url} target="_blank" rel="noopener noreferrer" className="underline hover:text-white">TikTok</a></>}
              </p>
            </div>
            <span className="text-sm font-bold text-[#FF4B00]">♥ {e.votes}</span>
            {!e.winner && (
              <button onClick={() => setWinner(e)} className="px-3 py-2 rounded-full bg-[#FFB800]/15 hover:bg-[#FFB800] text-[#FFB800] hover:text-black text-xs font-bold transition-colors" data-testid={`contest-winner-btn-${e.id}`}>
                👑 Ganadora
              </button>
            )}
            <button onClick={() => removeEntry(e)} aria-label="Eliminar participación" className="w-8 h-8 rounded-full bg-white/5 hover:bg-red-500/30 text-white/50 hover:text-red-300 flex items-center justify-center" data-testid={`contest-remove-btn-${e.id}`}>
              <Trash size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
